<template>
    <div class="main-summary">
        <div class="main-summary__totals">
            <el-card>
                <div class="content">
                    <div>
                        <i class="lyra-icon lyra-contrato" />
                        {{ translate('contracts_total') }}
                    </div>
                    <div>
                        <span>{{ summary.contracts_total }}</span>
                    </div>
                </div>
            </el-card>
            <el-card>
                <div class="content">
                    <div>
                        <i class="lyra-icon lyra-volume" />
                        {{ translate('volume_total') }}
                    </div>
                    <div>
                        <span>{{ formatters.formatNumber(summary.volume_total) }}</span>
                    </div>
                </div>
            </el-card>
            <el-card>
                <div class="content">
                    <div>
                        <i class="lyra-icon lyra-imoveis" />
                        {{ translate('property_total') }}
                    </div>
                    <div>
                        <span>{{ summary.properties_total }}</span>
                    </div>
                </div>
            </el-card>
        </div>
        <div class="main-summary__reproved" v-if="isRegistrant">
            <el-card>
                <div>
                    <span>{{ summary.contracts_reproved_total }}</span>
                    <span>
                        {{ $tc('contrato_rastreabilidade.messages.main_summary.contract_reproved', summary.contracts_reproved_total > 1 ? 2 : 1)}}
                    </span>
                    <el-link @click="search('REPROVADO')"> {{ translate('show_only_reproved') }}</el-link>
                </div>
            </el-card>
        </div>
        <div class="main-summary__pending">
            <el-card>
                <div>
                    <span>{{ summary.total_waiting_contracts }}</span>
                    <span>
                        {{ $tc('contrato_rastreabilidade.messages.main_summary.contract_pending', summary.total_waiting_contracts > 1 ? 2 : 1)}}
                    </span>
                    <el-link @click="search('ENVIADO')"> {{ translate('show_only_pending') }}</el-link>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import formatters from '@/utils/formatters';

export default {
    name: 'index',
    data() {
        return {
            formatters
        };
    },
    mounted() {
        const isRegistrant = this.$route.name === 'contrato-rastreabilidade';
        this.fetchSummary(isRegistrant);
    },
    computed: {
        ...mapState('traceabilityContractModule', ['summary']),
        ...mapGetters('traceabilityContractModule', ['isRegistrant', 'isApprover'])
    },
    methods: {
        ...mapActions('traceabilityContractModule', ['fetchSummary', 'fetchTraceabilityReports']),
        translate(key, params = {}) {
            const base = 'contrato_rastreabilidade.messages.main_summary';
            return this.$t(`${base}.${key}`, params);
        },
        search(status) {
            this.$store.commit('traceabilityContractModule/SET_FILTER', { status: [status], page: 0 });
        }
    }
};
</script>

<style scoped lang="scss">
.main-summary {
    .main-summary__totals {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-template-rows: auto auto;
        gap: 16px;
        @media (max-width: 768px) {
            grid-template-columns: 1fr;
        }

        .content {
            display: grid;
            grid-template-columns: 1fr auto;
            align-items: center;

            div:first-child {
                display: flex;
                align-items: center;
                gap: 16px;
                font-size: 16px;
                color: #00413c;
                font-weight: 500;
            }
            div:last-child {
                display: flex;
                align-items: center;
                span {
                    font-weight: 500;
                    font-size: 18px;
                    color: #00413c;
                }
            }
        }

        .lyra-icon::before {
            content: '';
            width: 24px;
            height: 24px;
            display: inline-block;
            background-color: #00413c;
            cursor: pointer;
        }
    }

    .main-summary__reproved {
        @media (max-width: 768px) {
           margin-top: 16px;
        }

        .el-card {
            border: 1px solid #F4C1BE;
            border-left: 8px solid #9C2621;

            div {
                display: flex;
                align-items: center;
                gap: 10px;
            }

            div > span:first-child {
                font-size: 22px;
                font-weight: 500;
            }

            div > span:last-child {
                font-size: 14px;
                font-weight: 600;
            }

            div .el-link {
                color: #2284DD;
                font-size: 14px;
                font-weight: 300;
            }
        }
    }

    .main-summary__pending {
        margin-top: 16px;

        .el-card {
            border: 1px solid #e6a23c;
            border-left: 8px solid #e6a23c;

            div {
                display: flex;
                align-items: center;
                gap: 10px;
            }

            div > span:first-child {
                font-size: 22px;
                font-weight: 500;
            }

            div > span:last-child {
                font-size: 14px;
                font-weight: 600;
            }

            div .el-link {
                color: #2284DD;
                font-size: 14px;
                font-weight: 300;
            }
        }
    }
}
</style>
